var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentimentVeryDissatisfied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27C19.84 27 15.88 29.92 14.28 34H34.72C33.12 29.92 29.16 27 24.5 27ZM16.14 24L18.26 21.88L20.38 24L22.5 21.88L20.38 19.76L22.5 17.64L20.38 15.52L18.26 17.64L16.14 15.52L14.02 17.64L16.14 19.76L14.02 21.88L16.14 24ZM24.48 4C13.44 4 4.5 12.94 4.5 24C4.5 35.06 13.44 44 24.48 44C35.52 44 44.5 35.06 44.5 24C44.5 12.94 35.54 4 24.48 4ZM24.5 40C15.66 40 8.5 32.84 8.5 24C8.5 15.16 15.66 8 24.5 8C33.34 8 40.5 15.16 40.5 24C40.5 32.84 33.34 40 24.5 40ZM32.86 15.52L30.74 17.64L28.62 15.52L26.5 17.64L28.62 19.76L26.5 21.88L28.62 24L30.74 21.88L32.86 24L34.98 21.88L32.86 19.76L34.98 17.64L32.86 15.52Z",
    fill: "#EB4B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentVeryDissatisfied);
export default __webpack_public_path__ + "static/media/sentiment_very_dissatisfied.ef314c939b8132c55af8099642b56984.svg";
export { ForwardRef as ReactComponent };